import { useCallback } from 'react'

import { ListBox, Select } from '@heroui/react'
import { useTranslation } from 'react-i18next'

interface RowsPerPageProps {
  value: number;
  onChange: (value: number) => void;
  options?: number[];
  className?: string;
}

export function RowsPerPage({
  value,
  onChange,
  options = [10, 20, 50, 100],
  className = '',
}: RowsPerPageProps) {
  const { t } = useTranslation()

  const handleSelectionChange = useCallback((key: any) => {
    if (key !== null && key !== undefined) {
      onChange(Number(key))
    }
  }, [onChange])

  return (
    <div className={`flex items-center gap-2 text-xs text-foreground/50 ${className}`}>
      <span>{t('common.rows_per_page')}</span>
      <Select
        className="w-16"
        selectedKey={String(value)}
        onSelectionChange={handleSelectionChange}
        variant={'secondary'}
      >
        <Select.Trigger className="flex items-center justify-between w-full px-2.5 py-1 rounded-xl bg-foreground/5 hover:bg-foreground/10 dark:bg-white/5 dark:hover:bg-white/10 transition-colors h-7 text-xs text-foreground font-medium">
          <Select.Value />
          <Select.Indicator className="ml-1" />
        </Select.Trigger>
        <Select.Popover className="min-w-[80px] p-1 bg-background border border-foreground/10 dark:border-white/10 rounded-xl shadow-lg">
          <ListBox>
            {options.map(val => (
              <ListBox.Item
                key={val}
                id={String(val)}
                textValue={String(val)}
                className="flex items-center justify-between px-2 py-1 text-xs rounded-lg hover:bg-foreground/5 cursor-pointer dark:text-white"
              >
                <span>{val}</span>
                <ListBox.ItemIndicator />
              </ListBox.Item>
            ))}
          </ListBox>
        </Select.Popover>
      </Select>
    </div>
  )
}
